import React, { createContext, useState } from 'react'

interface QrCodeType {
  contentJson: string
  setContentJson: React.Dispatch<React.SetStateAction<string>>
}

export const QRCodeContext = createContext<QrCodeType>({
  contentJson:'',
  setContentJson:() => {}
})

export const QrCodeProvider:React.FC<any> = ({children}) => {
  const [ contentJson, setContentJson ] = useState<string>('')
  
  return(
    <QRCodeContext.Provider value={{
      contentJson:contentJson,
      setContentJson:setContentJson
    }}>
      {children}
    </QRCodeContext.Provider>
  )
}